import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Dialogbox extends React.Component {
  state = {
    fullWidth: true,
    maxWidth: 'sm',
  };


  render() {
    const { classes } = this.props;
    let i = 0;
    let overallTotal = 0;
    return (
      <React.Fragment>
        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.props.open} onClose={this.props.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle>{this.props.title}</DialogTitle>
          <DialogContent>
            <table id="table" width="100%">
              <tr>
                <th id="tableheader"><center>Sino</center></th>
                <th id="tableheader"><center>{this.props.col2}</center></th>
                <th id="tableheader"><center>{this.props.col3}</center></th>
              </tr>
              { this.props.type == 'amount' ?
                (
                  <tbody>
                    { this.props.data.map((x) => {
                        i++;
                        let total = Number(x.total).toFixed(2);
                        let tot = Number(x.total);
                        overallTotal = overallTotal + tot;
                        return (
                          <tr>
                            <td><center>{i}</center></td>
                            <td>{x.branch_id+"->"+x.branch_name}</td>
                            <td style={{textAlign: 'right'}}>{"₹"+total}</td>
                          </tr>
                        )
                      })
                    }
                    <tr>
                      <td colspan="2" style={{textAlign: 'right'}}><b>Total</b></td>
                      <td style={{textAlign: 'right'}}>{"₹"+overallTotal.toFixed(2)}</td>
                    </tr>
                  </tbody>
                ) :
                (
                  <tbody>
                    { this.props.data.map((x) => {
                        i++;
                        let tot = Number(x.total);
                        overallTotal = overallTotal + tot;
                        return (
                          <tr>
                            <td><center>{i}</center></td>
                            <td><center>{x.branch_id+"->"+x.branch_name}</center></td>
                            <td style={{textAlign: 'right'}}>{tot}</td>
                          </tr>
                        )
                      })
                    }
                    <tr>
                      <td colspan="2" style={{textAlign: 'right'}}><b>Total</b></td>
                      <td style={{textAlign: 'right'}}>{overallTotal}</td>
                    </tr>
                  </tbody>
                )
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Dialogbox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Dialogbox);
